<router-outlet></router-outlet>

<ca-tooltip-outlet></ca-tooltip-outlet>

<ct-error-popup *ngIf="!isClosed && showError$ | async" class="error-popup-wrapper" (cbClose)="close()"></ct-error-popup>
